<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-13 16:28:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/modifyphone/components/CodeField/index.vue
-->
<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-13 16:25:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/modifyphone/components/CodeField/index.vue
-->
<template>
  <div class="code_phone">
    <van-field
      v-model="verifyCode"
      name="verifyCode"
      maxlength="6"
      type="number"
      center
      label="验证码"
      placeholder="请输入短信验证码"
      @input="verifyCodeChange"
    >
      <template #button>
        <div
          v-if="!showTime"
          :class="phone.length ? 'code_color' : 'code_color1'"
          class="code_get font12 font_weight400"
          @click="senderCode"
        >
          获取验证码
        </div>
        <div class="code_get font12 font_weight400">
          <van-count-down
            v-if="showTime"
            :time="time"
            format="ss秒后重发"
            @finish="finish"
          />
        </div>
      </template>
    </van-field>
  </div>
</template>
<script>
export default {
  props: {
    phone: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      verifyCode: "",
      showTime: false,
      senderText: "发送验证码",
      time: 60000
    };
  },
  methods: {
    verifyCodeChange(value) {
      this.$emit("input", value);
    },
    senderCode() {
      // this.$emit("senderCode");
      const reg = /^(1[3456789])\d{9}$/;
      if (!this.phone.trim()) {
        this.$toast("请输入手机号");
        return;
      }
      if (!reg.test(this.phone.trim())) {
        this.$toast("请输入正确的手机号");
        return;
      }
      const data = {
        phone: this.phone,
        kind: "ChangePhone"
      };
      this.$store
        .dispatch("login/sendSms", {
          params: data
        })
        .then(() => {
          this.showTime = true;
        })
        .catch(err => {
          this.errorMsg = err.message;
        });
    },
    finish() {
      this.senderText = "重新发送";
      this.showTime = false;
    }
  }
};
</script>
<style lang="less" scoped>
.code_phone {
  margin: 16px 12px 0;
}
::v-deep .van-cell {
  background: #f6f7f8;
  border-radius: 20px;
}
::v-deep .van-field__label {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
  font-weight: 500;
}
::v-deep .van-count-down {
  color: rgba(0, 0, 0, 0.38);
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}
.code_get {
  padding-left: 16px;
  border-left: 1px solid #d8d8d8;
  // color: #d91818;
  line-height: 14px;
}
.code_color {
  color: #d91818;
}
.code_color1 {
  color: rgba(0, 0, 0, 0.38);
}
</style>
